export const kiosksLoadingSelector = (state) => state.kiosks.loading;
export const kiosksSelector = (state) => state.kiosks.kiosks;
export const settingsPhotoTakeLoadingSelector = (state) => state.kiosks.loadingSettingsPhotoTake;
export const settingsPhotoTakeSelector = (state) => state.kiosks.settingsPhotoTake;
export const kiosksUsersLoadingSelector = (state) => state.kiosks.usersLoading;
export const kiosksUsersSelector = (state) => state.kiosks.users;
export const pinCodeGenerateLoadingSelector = (state) => state.kiosks.pinCodeGenerateLoading;
export const pinCodeSelector = (state) => state.kiosks.pinCode;
